export const brandFunnelStagesEndPoint = `brand-funnel-stages/cohort-deep-dive`;
export const questionnaireEndPoint = 'questionnaire';
